'use strict';

var data,
    prevData,
    height = 0,
    counter = 0,
    dataCount = 0;

$(document).ready(function () {

	if ($('[data-component="menu"]').length) {
		var menu = new Menu();
	}

	if ($('[data-component="libraries-list"]').length) {
		var librariesList = new LibrariesList();
	}

	if ($('[data-page="areas-detalhe"]').length) {
		var areasDetalhe = new AreasDetalhe();
	}

	if ($('[data-page="vagas"]').length) {
		var vagas = new Vagas();
	}

	if ($('[data-component="login-block"]').length) {
		var login = new Login();
	}

	if ($('[data-component="birthday-message"]').length) {
		var birthdayMessage = new BirthdayMessage();
	}

	if ($('[data-component="accordion"]').length) {
		var accordion = new Accordion();
	}

	// if ($('[data-component="structure"]').length) {
	// 	var structure = new Structure();
	// }

	if ($('[data-component="timeline"]').length) {
		var timeline = new Timeline();
	}

	$('.select').each(function () {
		$(this).find('span').text($(this).find('.custom-select option:selected').text());
	});

	$('.custom-select').on('change', function () {
		$(this).prev('span').text($(this).find('option:selected').text());
	});

	if ('[data-page="login"]') {

		if ($(window).width() > 768) {
			$("html, body").css('height', '100%');
		} else {
			if ($(window).height() > 600) {
				$("html, body").css('height', '100%');
			} else {
				$("html, body").css('min-height', '100%');
				$('[data-component="login-block"]').addClass('scroll');
			}
		}
	}

	if ($('[data-equalizer]').length) {
		if ($(window).width() >= 768) {
			$('[data-equalizer]').each(function (e) {
				data = $(this).attr('data-equalizer');
				if (counter < 1) {
					prevData = data;
					counter++;
				}
				if (data === prevData) {
					dataCount++;
					calculateHeight($(this), data);
				} else {
					counter = 0;
					height = 0;
					prevData = '';
					calculateHeight($(this), data);
				}
				if (dataCount === $('[data-equalizer="' + data + '"]').length) {
					$('[data-equalizer="' + data + '"] > div').height(height);
					// dataCount = 0;
				}
			});
		}
	}

	$('.icon-star').on('click', function () {
		$(this).toggleClass('favorite');
	});

	if ($('table').length > 0) {
		$('table').each(function () {
			$(this).wrap('<div class="overlay"></div>');
		});
	}
});

function calculateHeight(item, data) {
	console.log(height);

	if (item.height() > height) {
		height = item.outerHeight();
	}
}

$(window).on('load', function () {
	if ($('.scrollbar-inner').length) {
		if ($('.scrollbar-inner').closest('.modal').length > 0) {
			$('.scrollbar-inner').mCustomScrollbar({
				axis: "yx"
			});
		} else {
			$('.scrollbar-inner').mCustomScrollbar();
		}
	}
});
'use strict';

var BirthdayMessage = function BirthdayMessage() {

	var comp = $('[data-component="birthday-message"]');

	this.init = function () {

		accordion();
	};

	function accordion() {
		$('.birthday-list').each(function () {
			var $accordion = $(this);

			$accordion.find('.birthday-head').on('click', function (e) {
				e.preventDefault();

				$accordion.find('.birthday-body').slideUp();
				$('.btn-arrow').removeClass('active');

				if (!$(this).next().is(':visible')) {
					$(this).find('.btn-arrow').addClass('active');
					$(this).next().slideDown();
				}
			});
		});
	}

	return this.init();
};
'use strict';

var Timeline = function Timeline() {

	var comp = $('[data-component="timeline"]'),
	    $item;

	this.init = function () {

		comp.find('.holder-arrow').on('click', function () {

			$item = $(this).closest('.timeline-item');

			$item.find('.see-message').slideUp();
			$item.find('.btn-arrow').removeClass('active');
			$item.find('.legend').text('Expandir');

			if (!$item.find('.see-message').is(':visible')) {
				$item.find('.legend').text('Retrair');

				$item.find('.btn-arrow').addClass('active');
				$item.find('.see-message').slideDown();
			}
		});

		$('.btn-message').on('click', function () {
			$('[data-component="modal"] .person .name').text($(this).closest('.content').find('.name').text());
		});

		$('[data-component="modal"] .close-modal').on('click', function () {
			$('[data-component="modal"] .person .name').text('');
		});
	};

	return this.init();
};
'use strict';

var Menu = function Menu() {

	var comp = $('[data-component="menu"]');

	this.init = function () {

		toggleSubmenu();

		toggleSubitem();

		toggleMenuMobile();
	};

	function toggleMenuMobile() {
		$('.menu-mobile').on('click', function () {
			var menu = $('.menu-holder');

			if (menu.length > 0 && !menu.hasClass('open')) {
				TweenMax.set(menu, { height: 'auto' });
				TweenMax.from(menu, .8, { height: 0, ease: Quint.easeOut });

				menu.addClass('open');
				$(this).addClass('opened');
			} else {
				TweenMax.to(menu, .8, { height: 0, ease: Quint.easeOut });
				$('.submenu-list').removeClass('open');
				$('.subitem-list').removeClass('open');
				TweenMax.to($('.submenu-list'), .3, { height: 0, ease: Quint.easeOut });
				TweenMax.to($('.subitem-list'), .3, { height: 0, ease: Quint.easeOut });
				menu.removeClass('open');
				$(this).removeClass('opened');
			}
		});
	}

	function toggleSubmenu() {
		if ($(document).width() > 768) {
			comp.find('.menu-item, .profile-holder').hover(function () {

				var submenu = $(this).find('.submenu-list');

				console.log($(this));

				if ($(this).hasClass('profile-holder')) {

					console.log('test');

					if (submenu.length > 0) {
						TweenMax.to(submenu, .8, { top: '80px', opacity: 1, autoAlpha: 1, ease: Quint.easeOut });
					}
				} else {

					console.log('dsda');

					if (submenu.length > 0) {
						TweenMax.to(submenu, .8, { top: '60px', opacity: 1, autoAlpha: 1, ease: Quint.easeOut });
					}
				}
			}, function () {

				var submenu = $(this).find('.submenu-list');

				if (submenu.length > 0) {
					TweenMax.to(submenu, .4, { top: '40px', opacity: 0, autoAlpha: 0, ease: Quint.easeOut });
				}
			});
		} else {
			comp.find('.menu-item, .profile-holder').on('click', function () {
				var submenu = $(this).find('.submenu-list');

				if (submenu.length > 0 && !submenu.hasClass('open')) {
					$('.submenu-list').removeClass('open');
					$('.subitem-list').removeClass('open');
					TweenMax.to($('.subitem-list'), .3, { height: 0, ease: Quint.easeOut });
					TweenMax.to($('.submenu-list'), .3, { height: 0, ease: Quint.easeOut,
						onComplete: function onComplete() {
							TweenMax.set(submenu, { height: 'auto' });
							TweenMax.from(submenu, .8, { height: 0, ease: Quint.easeOut });
							submenu.addClass('open');
						}
					});
				} else {
					TweenMax.to(submenu, .8, { height: 0, ease: Quint.easeOut });

					submenu.removeClass('open');
				}
			});
		}
	}

	function toggleSubitem() {
		if ($(document).width() > 768) {
			comp.find('.submenu-item').hover(function () {

				var subitem = $(this).find('.subitem-list');

				if (subitem.length > 0) {
					TweenMax.to(subitem, .8, { opacity: 1, autoAlpha: 1, ease: Quint.easeOut });
				}
			}, function () {

				var subitem = $(this).find('.subitem-list');

				if (subitem.length > 0) {
					TweenMax.to(subitem, .4, { opacity: 0, autoAlpha: 0, ease: Quint.easeOut });
				}
			});
		} else {
			comp.find('.submenu-item').on('click', function (e) {
				var subitem = $(this).find('.subitem-list');
				TweenMax.to($('.subitem-list'), .8, { height: 0, ease: Quint.easeOut });

				if (subitem.length > 0 && !subitem.hasClass('open')) {
					$('.subitem-list').removeClass('open');
					TweenMax.to($('.subitem-list'), .3, { height: 0, ease: Quint.easeOut,
						onComplete: function onComplete() {
							TweenMax.set(subitem, { height: 'auto' });
							TweenMax.from(subitem, .8, { height: 0, ease: Quint.easeOut });
							subitem.addClass('open');
						}
					});
				} else {
					TweenMax.to(subitem, .8, { height: 0, ease: Quint.easeOut });

					subitem.removeClass('open');
				}

				e.stopPropagation();
			});
		}
	}

	return this.init();
};
'use strict';

var Accordion = function Accordion() {

	var comp = $('[data-component="accordion"]');

	this.init = function () {

		accordion();
	};

	function accordion() {
		$('.accordion-list').each(function () {
			var $accordion = $(this);

			$accordion.find('.accordion-header').on('click', function (e) {
				e.preventDefault();

				$accordion.find('.accordion-body').slideUp();
				$('.btn-arrow').removeClass('active');
				$('.legend').text('Expandir');

				if (!$(this).next().is(':visible')) {
					$(this).find('.legend').text('Retrair');

					$(this).find('.btn-arrow').addClass('active');
					$(this).next().slideDown();
				}
			});
		});
	}

	return this.init();
};
'use strict';

var BlockSlider = function BlockSlider() {

	var comp = $('[data-component="block-slider"');

	this.init = function () {

		initBlockSlider();
	};

	function initBlockSlider() {
		comp.find('.slider').slick({
			infinite: true,
			dots: false
		});
	}

	return this.init();
};
'use strict';

var CardSlider = function CardSlider() {

	var comp = $('[data-component="card-slider"]');

	this.init = function () {

		initSliderBanner();

		initSliderSmallCard();
	};

	function initSliderBanner() {
		comp.find('.slider.banner').slick({
			infinite: false,
			dots: true
		});
	}

	function initSliderSmallCard() {
		comp.find('.slider.small-card').slick({
			infinite: true,
			dots: false
		});
	}

	return this.init();
};
"use strict";

var FilterCalendar = function FilterCalendar() {

	var comp = $('[data-component="filter-calendar"]');

	this.init = function () {

		datepicker();
	};

	function datepicker() {

		$.datepicker.regional["pt-BR"] = {
			closeText: "Fechar",
			prevText: "&#x3C;Anterior",
			nextText: "Próximo&#x3E;",
			currentText: "Hoje",
			monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
			monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
			dayNames: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
			dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
			dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
			weekHeader: "Sm",
			dateFormat: "dd/mm/yy",
			firstDay: 0,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ""
		};
		$.datepicker.setDefaults($.datepicker.regional["pt-BR"]);
		comp.find('#datepicker').on('click', function () {
			$(this).datepicker({
				autoClose: true,
				changeMonth: true,
				changeYear: true,
				showButtonPanel: false,
				dateFormat: 'MM yy',
				onSelect: function onSelect(dateText, inst) {
					var time = dateText;
					time = time.split('/');
					comp.find('.month').val(time[1]);
					comp.find('.year').val(time[2]);
					$(this).datepicker("destroy");
					$(this).html('<span class="icon-calendar"></span>');
				}
			});
		});
	}

	return this.init();
};
'use strict';

var Login = function Login() {

	var comp = $('[data-component="login-block"]');

	this.init = function () {

		$('#login').validate({
			ignore: '.ignore',
			errorPlacement: function errorPlacement() {
				return true;
			},
			rules: {
				mail: {
					required: true,
					email: true
				},
				password: {
					required: true
				}
			},
			submitHandler: function submitHandler(form) {
				// form.submit();
			}
		});
	};

	return this.init();
};
'use strict';

var LibrariesList = function LibrariesList() {

	var comp = $('[data-component="libraries-list"]'),
	    filter = $('[data-component="libraries-filter"]'),
	    itens = $('[data-component="library-item"]');

	this.init = function () {

		check();

		filterList();
	};

	function check() {

		itens.each(function () {
			if ($(this).data('category') === filter.find('.active').data('id')) {
				$(this).fadeIn(300);
			}
		});
	}

	function filterList() {

		filter.find('a').on('click', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('active')) {
				filter.find('a').removeClass('active');
				$(this).addClass('active');
				itens.fadeOut(300);
				setTimeout(function () {
					check();
				}, 305);
			}
		});
	}

	return this.init();
};
'use strict';

var Structure = function Structure() {

	var comp = $('[data-component="structure"]');

	this.init = function () {

		// $('.scrollbar-inner').scrollbar();

	};

	return this.init();
};
'use strict';

var AreasDetalhe = function AreasDetalhe() {

	var page = $('[data-page="areas-detalhe"]');

	this.init = function () {

		if ($(window).width() > 768) {
			blocksPosition();
		}
	};

	function blocksPosition() {
		page.find('.list').masonry({
			horizontalOrder: true
		});
	}

	return this.init();
};
'use strict';

var Vagas = function Vagas() {

	var page = $('[data-page="vagas"]');

	this.init = function () {

		if ($(window).width() > 768) {
			blocksPosition();
		}
	};

	function blocksPosition() {
		page.find('.list').masonry({
			horizontalOrder: true
		});
	}

	return this.init();
};